import { BracketRoundHeader, ShuffleColumn } from "../styles";
import {
  depthToRoundTitleSingleElim,
  getMaxDepth,
  getNodesByDepth,
  ShuffleBracketGraph,
  ShuffleBracketNode,
} from "model/Bracket/ShuffleBracketGraph";
import { ShuffleBracketRowMatch } from "./ShuffleBracketRowMatch";
import { BracketMatchArgs } from "../BracketMatchArgs";
import { FlexRow } from "styles/layout";
import { JSX } from "react";

interface Props {
  bracketGraph: ShuffleBracketGraph;
  tournamentId: string;
  bracketMatchArgs?: BracketMatchArgs;
}

export const MultiLevelBracket = ({
  bracketGraph,
  tournamentId,
  bracketMatchArgs,
}: Props) => {
  const nodesByDepth = getNodesByDepth(
    bracketGraph.finalNodes,
    false
  ).reverse();
  const maxDepth = getMaxDepth(nodesByDepth.flat());
  const nodeColumns = nodesByDepth.map((n, i) =>
    mapColumn(
      n,
      maxDepth - i - 1,
      maxDepth,
      nodesByDepth[0].length > 1,
      tournamentId
    )
  );

  return (
    <div style={{ padding: "10px", marginTop: "10px" }}>
      <FlexRow style={{ alignItems: "flex-start" }}>
        {nodeColumns.map(({ nodeCells, roundTitle }) => (
          <ShuffleColumn>
            <BracketRoundHeader isLower={false}>
              {roundTitle}
            </BracketRoundHeader>
            {nodeCells}
          </ShuffleColumn>
        ))}
      </FlexRow>
    </div>
  );
};

const mapColumn = (
  nodes: ShuffleBracketNode[],
  depth: number,
  maxDepth: number,
  hasMultipleFinals: boolean,
  tournamentId: string
) => {
  const nodeCells: JSX.Element[] = [];
  for (var i = 0; i < nodes.length; i++) {
    nodeCells.push(
      <ShuffleBracketRowMatch node={nodes[i]} tournamentId={tournamentId} />
    );
  }

  return {
    nodeCells,
    roundTitle: depthToRoundTitleSingleElim(
      depth + 1,
      maxDepth,
      hasMultipleFinals
    ),
  };
};
